import { render, staticRenderFns } from "./NewsAppProCmptNA.vue?vue&type=template&id=6241405e&scoped=true&"
import script from "./NewsAppProCmptNA.vue?vue&type=script&lang=ts&"
export * from "./NewsAppProCmptNA.vue?vue&type=script&lang=ts&"
import style0 from "./NewsAppProCmptNA.vue?vue&type=style&index=0&id=6241405e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6241405e",
  null
  
)

export default component.exports